import { render } from "./AuditStatusBanner.vue?vue&type=template&id=f06d5a8a"
import script from "./AuditStatusBanner.vue?vue&type=script&lang=js"
export * from "./AuditStatusBanner.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__